const { makeStyles } = require('@material-ui/core');

export const tableActionButtonStyles = makeStyles({
  buttonContainer: {
    color: 'white',
    borderRadius: '30%',
    padding: 4,
    border: 0,
    backgroundColor: 'rgba(88, 144, 170, 0.8)',
    '&:hover': {
      backgroundColor: 'rgba(88, 144, 170, 1)',
      boxShadow: 'none',
      borderColor: 'rgba(88, 144, 170, 0)',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: 'rgba(88, 144, 170, 0.9)',
      borderColor: 'rgba(88, 144, 170, 0)',
    },
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgba(88, 144, 170,0.9)',
      borderColor: 'rgba(88, 144, 170, 0)',
    },
  },
});
